import React, { useState } from 'react';

import { Modal, Form, Spinner } from 'react-bootstrap';
import { Button } from '../../components';

const DeclineReasonModal = ({ show, onHide, onDecline, loading }) => {
  const [reason, setReason] = useState('');

  const handleDecline = () => {
    onDecline(reason);
    setReason('');
  };

  const handleCancel = () => {
    onHide();
    setReason('');
  };

  return (
    <Modal show={show} onHide={handleCancel} centered onKeyDown={e => { if (e.key === 'Enter') e.preventDefault(); }}>
      <Modal.Header>
        <Modal.Title>Declined Reason</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please provide a reason for declining that the driver will see.</p>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={3}
            value={reason}
            onChange={e => setReason(e.target.value)}
            maxLength={150}
          />
          <div className="d-flex justify-content-end mt-1">
            <small>{reason.length}/150</small>
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onPress={handleDecline}
          disabled={!reason.trim() || loading}
          text={loading ? <Spinner animation="border" size="sm" /> : 'Decline'}
        />
        <Button
          variant="secondary"
          onPress={handleCancel}
          disabled={loading}
          text="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default DeclineReasonModal;
